// Batch Studio V1 lite (UI corr v4.03.8) —
// The hover popover was removed (it mispositioned). This component now only
// renders the re-edit confirmation modal. All export status/wording lives in
// the full-width sticky bar in App.js (.export-bar-wrap). The <style> keeps
// emitting the @keyframes spin used by that bar's spinner.

import React from 'react';
import { createPortal } from 'react-dom';

const ORANGE  = '#F97316';
const BORDER  = '1px solid #e0e0e0';
const FONT    = 'DM Sans, sans-serif';

const btnPrimary = {
  background: ORANGE, color: '#fff', border: 'none', borderRadius: 8,
  padding: '8px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: FONT,
};
const btnSecondary = {
  padding: '8px 14px', border: BORDER, borderRadius: 6, background: '#fff',
  cursor: 'pointer', fontSize: 12, fontFamily: FONT,
};
const modalOverlay = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(10,10,10,0.55)', display: 'flex', alignItems: 'center',
  justifyContent: 'center', zIndex: 99999,
};
const modalBox = {
  background: '#fff', borderRadius: 10, padding: 20, maxWidth: 380, width: '90%', fontFamily: FONT,
};

function Portal({ children }) {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}

export default function BatchStudioPanel({
  queue, results,
  reeditTarget, setReeditTarget, confirmReedit,
}) {
  if (!queue || queue.length === 0) return null;

  const reeditNode = reeditTarget ? (
    <Portal>
      <div style={modalOverlay} onClick={() => setReeditTarget(null)}>
        <div style={modalBox} onClick={e => e.stopPropagation()}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 10 }}>
            Re-edit this video?
          </div>
          <div style={{ fontSize: 12, color: '#555', marginBottom: 16 }}>
            It goes back to the queue as <b>Ready to edit</b>, with every setting you made, and leaves the exported bar.
            Its {results.filter(r => r.sourceQueueId === reeditTarget.id && !r.isOriginal).length} rendered version(s) are removed;
            you will need to export it again.
          </div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button style={btnSecondary} onClick={() => setReeditTarget(null)}>
              Cancel
            </button>
            <button style={btnPrimary} onClick={confirmReedit}>
              Re-edit
            </button>
          </div>
        </div>
      </div>
    </Portal>
  ) : null;

  return (
    <>
      {reeditNode}
      {/* @keyframes spin is used by the App.js bottom render-bar spinner. */}
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </>
  );
}
